/** Authenticator app download/info URLs (shared between setup-mfa and ChangeMFAPanel) */
export const GOOGLE_AUTHENTICATOR_URL =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2";
export const MICROSOFT_AUTHENTICATOR_URL = "https://www.microsoft.com/en-us/security/mobile-authenticator-app";
export const AUTHY_URL = "https://authy.com/";
